import React from 'react';

/**
 * Componente de tarjeta para la selección de agentes
 * Muestra el icono, nombre y descripción del agente
 */
const AgentCard = ({ icon, name, description, onClick }) => {
  const IconComponent = React.isValidElement(icon) 
    ? React.cloneElement(icon, { size: 32, className: 'text-blue-600 dark:text-blue-400' }) 
    : null;

  return (
    <div 
      className="flex flex-col p-6 border border-gray-200 dark:border-gray-700 rounded-xl cursor-pointer
                 bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl 
                 hover:border-blue-500 dark:hover:border-blue-400
                 transition-all duration-300 transform hover:-translate-y-1 group relative" 
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      aria-label={`Seleccionar agente ${name}`}
    >
      {/* Header: Icono y Nombre del Agente */}
      <div className="flex items-center mb-4"> 
        {/* Icono con fondo */}
        <div className="mr-4 flex items-center bg-blue-100 dark:bg-blue-900/50 rounded-lg p-3">{IconComponent}</div>
        <h3 className="text-sm font-semibold text-gray-800 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
          {name}
        </h3>
      </div>
      
      {/* Descripción del Agente */} 
      <div className="flex-grow text-xs text-gray-600 dark:text-gray-400 max-w-full">
        <p>
          {description}
        </p>
      </div>
    </div>
  );
};

export default AgentCard;
